import { KoobButton } from '@koob/ui';
import { useTranslation } from 'react-i18next';

export default function ReceiptFooter({
  onSave,
  onCancel,
  isSaving = false,
  isSaveDisabled = false,
}) {
  const { t } = useTranslation('misc');

  return (
    <>
      <div className="h-16 w-full" aria-hidden="true" />

      <div className="fixed bottom-0 left-0 right-0 z-sticky bg-white border-t border-slate-200 shadow-[0_-4px_10px_rgba(0,0,0,0.03)] py-3 px-8 export-hidden">
        <div className="flex justify-end gap-3 max-w-6xl mx-auto">
          <KoobButton
            variant="secondary"
            size="lg"
            type="button"
            onClick={onCancel}
            disabled={isSaving}
          >
            {t('cancel')}
          </KoobButton>

          <KoobButton
            variant="primary"
            size="lg"
            type="button"
            onClick={onSave}
            loading={isSaving}
            disabled={isSaving || isSaveDisabled}
          >
            {t('save')}
          </KoobButton>
        </div>
      </div>
    </>
  );
}
